export default {
  en: {
    'TABLE': 'Table',
    'BAR': 'Bar',
    'PIE': 'Pie',
    'FULL_EXPORT': 'Full Export',
    'SELECTED_COLS': 'Selected Columns',
    'SCHEDULE': 'Schedule',
    'SCHEDULE_TIP': 'Schedule email delivery of the report:',
    'HOURLY': 'Hourly',
    'HOURLY_TIP': 'Select the minute of the hour to schedule delivery of report:',
    'DAILY': 'Daily',
    'DAILY_TIP': 'Select the hour of the day to schedule delivery of report:',
    'WEEKLY': 'Weekly',
    'WEEKLY_TIP': 'Select the day of the week to schedule delivery of report:',
    'MONTHLY': 'Monthly',
    'MONTHLY_TIP': 'Select the day of the month to schedule delivery of report:',
  }
};